export default __webpack_public_path__ + "hero-0fd5d9e6e4f2974aee255a79016fff8d.digested.jpg";